import { CustomSelector, ECustomSelector } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { TFormBuilderDropdownField, TNullable } from '@/types';

type TProps = {
  field: TFormBuilderDropdownField;
};

/**
 * Preview component for dropdown field in form builder
 * @param props - Component props
 * @param props.field - Dropdown field data to preview
 * @returns Form builder dropdown preview component
 */
export const FormBuilderPreviewDropdown = ({ field }: TProps) => {
  const [value, setValue] = useState<TNullable<string>>(null);
  return (
    <CustomSelector
      labelProps={{ label: field.label, required: !!field.required }}
      placeholder={field.placeholder}
      type={ECustomSelector.Select}
      selected={value ?? undefined}
      options={field.options.map(({ id, value }) => ({ id, title: value }))}
      onChange={(v) => setValue(v)}
      sx={{ maxWidth: '343px', width: '100%' }}
    />
  );
};
